import { Box } from '@mui/material';

interface CardOwnerLabelProps {
  ownerName: string;
  placement?: 'inside' | 'below';
}

export function CardOwnerLabel({ ownerName, placement = 'inside' }: CardOwnerLabelProps) {
  if (!ownerName) {
    return null;
  }

  const isBelow = placement === 'below';

  return (
    <Box
      sx={{
        alignItems: 'center',
        bgcolor: 'rgba(255, 255, 255, 0.7)',
        borderTop: isBelow ? 0 : '1px solid #f3f5f8',
        color: '#111',
        display: 'flex',
        fontSize: 12,
        gap: 0.5,
        justifyContent: isBelow ? 'center' : 'flex-start',
        left: isBelow ? '50%' : undefined,
        maxWidth: isBelow ? '100%' : undefined,
        minWidth: 0,
        pointerEvents: isBelow ? 'none' : undefined,
        position: isBelow ? 'absolute' : undefined,
        px: 0.75,
        py: 0.5,
        textAlign: isBelow ? 'center' : undefined,
        top: isBelow ? 'calc(100% + 6px)' : undefined,
        transform: isBelow ? 'translateX(-50%)' : undefined,
        whiteSpace: 'nowrap',
      }}
    >
      {ownerName && (
        <Box component="span" sx={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {ownerName}
        </Box>
      )}
    </Box>
  );
}
